import Typography from "typography"
import CodePlugin from 'typography-plugin-code'

//import fairyGateTheme from "typography-theme-fairy-gates"
//const typography = new Typography(fairyGateTheme)

//import twinPeaksTheme from 'typography-theme-twin-peaks'
//const typography = new Typography(twinPeaksTheme)
import githubTheme from 'typography-theme-github'
githubTheme.plugins = [
  new CodePlugin(),
]
 
const typography = new Typography(githubTheme)
module.exports = typography



// WEBPACK FOOTER //
// ./src/utils/typography.js